import React, { Fragment } from "react";
import { Button, T } from '../uikit-b2c/uikit-b2c';
export const PSlogin = ({ flatten = true }) => {
  return (<Fragment>

<div style={{display: 'flex', alignItems: 'center'}}>
    <Button
      // appearance="flatten"
      appearance="ghost" size="sm">
      Log&nbsp;in
      </Button>
      <T sm style={{paddingLeft: '1em'}}>
      to use your saved payment methods and balance
      </T>
    </div>

  </Fragment>);
};
